module.exports = __webpack_public_path__ + "img/logo.7b5b0f86.png";